import Vue from 'vue'
import App from './App.vue'
import VueSocketIO from 'vue-socket.io'
import { router } from '@/router'
import VueGtag from 'vue-gtag'

import { PageLayout, EditWebsite, GuestCardOrder, Contributions, ImageFile, FriendsAndFamilyWishlist, FriendsAndFamilyWedding, FriendsAndFamilyContributions } from './Components'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import store from '../src/store/store'
import Vuelidate from 'vuelidate'

const {
  VUE_APP_SOCKET_API,
  VUE_APP_SOCKET_API_IE
} = process.env

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)

const gaId = window.siteVar.referer === 'IE' ? 'G-CT46K5CJXJ' : 'G-SKPFMZ4RJB'
Vue.use(VueGtag, { config: { id: gaId } })

Vue.component('PageLayout', PageLayout)
Vue.component('EditWebsite', EditWebsite)
Vue.component('GuestCardOrder', GuestCardOrder)
Vue.component('GuestCardOrder', Contributions)
Vue.component('ImageFile', ImageFile)
Vue.component('FriendsAndFamilyWishlist', FriendsAndFamilyWishlist)
Vue.component('FriendsAndFamilyWedding', FriendsAndFamilyWedding)
Vue.component('FriendsAndFamilyContributions', FriendsAndFamilyContributions)

Vue.use(
  new VueSocketIO({
    debug: false,
    connection: window.location.toString().indexOf("trailfinders.ie") > 0 ? VUE_APP_SOCKET_API_IE : VUE_APP_SOCKET_API,
    options: { path: '/so-api/barclay/socket' }
  })
)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
